import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { StoreContext } from "@/context";
import { ROUTE_PERMISSIONS } from "@/utils/permissions";

/**
 * 路由守卫组件
 * 根据用户权限控制路由访问
 * - 使用 StoreContext 中的 hasPermission 作为统一的权限判断入口
 * - 使用 ROUTE_PERMISSIONS 映射维护「路由 -> 权限」关系
 */
export function ProtectedRoute({ children }) {
  const location = useLocation();
  const { hasPermission } = useContext(StoreContext);

  const pathname = location.pathname;

  // 个人中心相关路由不需要权限检查
  if (pathname.startsWith("/profile")) {
    return children;
  }

  // 精确匹配路由权限
  if (ROUTE_PERMISSIONS[pathname]) {
    const allow = hasPermission(ROUTE_PERMISSIONS[pathname]);
    if (!allow) {
      return <Navigate to="/cases" replace />;
    }
    return children;
  }

  // 动态路由匹配，例如 /cases/:id
  for (const [route, permissions] of Object.entries(ROUTE_PERMISSIONS)) {
    const routePattern = route.replace(/:[^/]+/g, "[^/]+");
    const regex = new RegExp(`^${routePattern}$`);
    if (regex.test(pathname)) {
      const allow = hasPermission(permissions);
      if (!allow) {
        return <Navigate to="/cases" replace />;
      }
      return children;
    }
  }

  // 如果路由未配置在 ROUTE_PERMISSIONS 中，则默认允许访问
  return children;
}
